import { render, staticRenderFns } from "./AutoFlex.vue?vue&type=template&id=135c092d&scoped=true"
import script from "./AutoFlex.vue?vue&type=script&lang=ts"
export * from "./AutoFlex.vue?vue&type=script&lang=ts"
import style0 from "./AutoFlex.vue?vue&type=style&index=0&id=135c092d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c092d",
  null
  
)

export default component.exports